import { type ReactNode } from 'react';

import { CardContentLayout } from '../../../components/CardContentLayout';
import { PromotionDescriptionContainer } from '../../PromotionDescriptionContainer';

import { ContentActionsContainer } from './ContentActionsContainer';
import { DescriptionContainer } from './DescriptionContainer';
import { GeoContainer } from './GeoContainer';
import { LabelsContainer } from './LabelsContainer';
import { PriceContainer } from './PriceContainer';
import { PublisherNarrowContainer } from './PublisherNarrowContainer';
import { SubtitleContainer } from './SubtitleContainer';
import { TitleContainer } from './TitleContainer';

export function ContentContainer(): ReactNode {
  return (
    <CardContentLayout
      actions={<ContentActionsContainer />}
      description={<DescriptionContainer />}
      geo={<GeoContainer />}
      labels={<LabelsContainer />}
      price={<PriceContainer />}
      promotion={<PromotionDescriptionContainer />}
      publisher={<PublisherNarrowContainer />}
      subtitle={<SubtitleContainer />}
      title={<TitleContainer />}
    />
  );
}
